import Immutable from 'immutable';
import { ProjectId } from 'records/Project';

export interface RawNewRFIAttachment {
  projectid: ProjectId;
  parentid: string;
  fileid: string;
  name: string;
  type: string;
}

export interface NewRFIAttachmentData {
  projectid: ProjectId;
  parentid: string;
  fileid: string;
  name: string;
  type: string;
}

const defaultValues: NewRFIAttachmentData = {
  projectid: '',
  parentid: '',
  fileid: '',
  name: '',
  type: '',
};

export const NewRFIAttachmentFactory = Immutable.Record(
  defaultValues,
  'NewRFIAttachment'
);

export class NewRFIAttachment extends NewRFIAttachmentFactory {
  static deserialize(
    rawNewRFIAttachment: RawNewRFIAttachment
  ): NewRFIAttachment {
    return new NewRFIAttachment({
      ...rawNewRFIAttachment,
    });
  }

  serialize(): RawNewRFIAttachment {
    return this.toJS();
  }
}
